let moduleExports = {};
const r = require.context('./', true, /^\.\/.+\/.+\.js$/);
for (var i in r) {}
r.keys().forEach(key => {
	let attr = key.substring(key.lastIndexOf('/') + 1, key.lastIndexOf('.'));
	moduleExports[attr] = r(key);
});
module.exports = moduleExports;



// WEBPACK FOOTER //
// ./src/api/index.js